import { render, staticRenderFns } from "./ABTestWrapper.vue?vue&type=template&id=661be026&scoped=true"
import script from "./ABTestWrapper.vue?vue&type=script&lang=ts"
export * from "./ABTestWrapper.vue?vue&type=script&lang=ts"
import style0 from "./ABTestWrapper.vue?vue&type=style&index=0&id=661be026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661be026",
  null
  
)

export default component.exports